import { z, ZodType } from 'zod'

import { MAX_SAFE_GQL_INTEGER } from 'providers/graphql/constants'

export const prebidTimeout: ZodType<number> = z.number().min(100).max(6_000)

export const consentManagementSchema = z.object({
  gdprTcfEnabled: z.boolean(),
  gdprTcfTimeout: z.number().min(0).max(MAX_SAFE_GQL_INTEGER),
  gppControlUsNat: z.boolean(),
  gppControlUsStates: z.boolean(),
  gppEnabled: z.boolean(),
  gppTimeout: z.number().min(0).max(MAX_SAFE_GQL_INTEGER),
  prebidTimeout,
  usPrivacyCcpaEnabled: z.boolean(),
  usPrivacyCcpaTimeout: z.number().min(0).max(MAX_SAFE_GQL_INTEGER),
})

export type ConsentManagementSchema = z.infer<typeof consentManagementSchema>
